export function isInvalidDictionaryWord(str: string): boolean {
  const onlyPunc = isOnlyPunctuation(str);
  const onlyNumbers = isOnlyNumbers(str);
  const onlyNumbersAndPunctuation = isOnlyNumbersAndPunctuation(str);
  return onlyPunc || onlyNumbers || onlyNumbersAndPunctuation;
}

function isOnlyNumbersAndPunctuation(str: string): boolean {
  return /^[\p{N}\p{P}\p{S}]+$/u.test(str);
}

function isOnlyPunctuation(str: string): boolean {
  return /^[\p{P}\p{S}]+$/u.test(str);
}

function isOnlyNumbers(str: string): boolean {
  return /^[\p{N}]+$/u.test(str);
}
